import styled from 'styled-components';

import { StyleColor, NewStyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const Wrapper = styled('div')`
	padding: 15px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.Black, 50)};
`;

const InnerWrapper = styled('div')`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
`;

const StatusLabel = styled('div')`
	display: flex;
	align-items: center;
	margin-bottom: 10px;

	svg {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		fill: ${NewStyleColor.VibrantGreen};
	}
`;

const EmailWrapper = styled('div')`
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	margin-right: 20px;
	overflow: hidden;
`;

const Email = styled('div')`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

const ButtonRemove = styled('button')`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 26px;
	width: 26px;
	height: 26px;
	margin-left: 10px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	outline: 0;
	background-color: ${StyleColor.Grey100};
	cursor: pointer;

	svg {
		width: 10px;
		height: 10px;
		fill: ${StyleColor.Grey450};
	}
`;

const ButtonIntegrate = styled('button')`
	box-sizing: border-box;
	min-width: 145px;
	height: 50px;
	margin-bottom: 10px;
	padding: 0 10px;
	border: 0;
	border-radius: 9px;
	outline: 0;
	background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 10)};
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 18px;
	line-height: 50px;
	cursor: pointer;
	transition: background-color 0.2s;
	white-space: nowrap;

	&:hover {
		background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.actionColor, 25)};
	}
`;

export {
	Wrapper,
	InnerWrapper,
	StatusLabel,
	EmailWrapper,
	Email,
	ButtonRemove,
	ButtonIntegrate,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/EmailIntegration/styles.ts